import React from 'react';
import Message from '../message/Message';
import PropTypes from 'prop-types';
import {generateAppPath} from 'epic-common/src/route';
import Footer from '../sections/footer/Footer';

const Error404 = function Error404({staticContext}) {
    if (staticContext) {
        staticContext.status = 404;
    }
    const homeLink = generateAppPath('/home');
    return (
        <div className="error404 errorPages">
            <div className="content">
                <div className="errorHeader">
                    <h1><Message code="epic.odin.404" /></h1>
                    <h3><Message code="epic.odin.404.subtitle" /></h3>
                    <a className="btn" href={homeLink}>
                        <Message code="epic.odin.home.title" />
                    </a>
                </div>
            </div>
            <Footer />
        </div>
    );
};

Error404.propTypes = {
    staticContext: PropTypes.object
};

export default Error404;
